import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-percentage",
  "use": "icon-percentage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-percentage\">\n  <path d=\"M761.1 824c-12.7 0-25.4-4.9-35.1-14.6L262.9 346.3c-19.3-19.3-19.3-50.9 0-70.2s50.9-19.3 70.2 0L796.2 739.2c19.3 19.3 19.3 50.9 0 70.2-9.7 9.7-22.4 14.6-35.1 14.6z\" fill=\"currentColor\" p-id=\"18427\" />\n  <path d=\"M304 352c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z m0-128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z\" fill=\"currentColor\" p-id=\"18428\" />\n  <path d=\"M720 864c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z m0-128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z\" fill=\"currentColor\" p-id=\"18429\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/percentage.svg
// module id = 39eH
// module chunks = 117